import { ConsentStory } from '@aclass/admin/storage/actions';
import {
    IConsentModuleState,
    INITIAL_CONSENT_STATE
} from '@aclass/admin/storage/states';
import { Action } from '@aclass/core/storage/action';
import { TypedState } from '@aclass/core/storage/states/module.state';
import { fromJS, List, Map } from 'immutable';

export const consentModuleReducer = (state: TypedState<IConsentModuleState> = INITIAL_CONSENT_STATE, action: Action) => {
    const { type, payload } = action;
    switch (type) {
        case ConsentStory.SEARCH_PAGE_UPDATE_INIT_STATE:
            return state.update('searchPageInitialized', () => payload);
        case ConsentStory.SEARCH_PAGE_UPDATE_COLLAPSED:
            return state.update('searchPageCollapsed', () => payload);
        case ConsentStory.SEARCH_PAGE_UPDATE_FORM:
            return state.update('searchPageForm', () => fromJS(payload));
        case ConsentStory.SEARCH_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('searchPageLock', () => payload);
        case ConsentStory.SEARCH_PAGE_UPDATE_PAGINATION:
            return state.update('searchPagePagination', () => Map(payload));
        case ConsentStory.SEARCH_PAGE_UPDATE_ORDER:
            return state.update('searchPageOrder', () => Map(payload));
        case ConsentStory.SEARCH_PAGE_IMPORT_RECORDS:
            return state.update('searchPageResults', () => List(payload));
        case ConsentStory.CREATE_PAGE_UPDATE_SAVE_LOCK:
            return state.update('createPageSaveLock', () => payload);
        case ConsentStory.EDIT_PAGE_UPDATE_ID:
            return state.update('editPageRecordId', () => payload);
        case ConsentStory.EDIT_PAGE_UPDATE_FORM:
            return state.update('editPageForm', () => fromJS(payload));
        case ConsentStory.EDIT_PAGE_UPDATE_CODE_FORM:
            return state.update('editPageCodeForm', () => List(payload));
        default:
            return state;
    }
};
